export function getStationCode() {
    const params = new URLSearchParams(window.location.search);
    return params.get('stationCode');
}



// WEBPACK FOOTER //
// ./src/components/network/NetworkUtil.js